import {getApiUrl} from "./client";

export type PendingHotspotHabitatFeedbackItem = {
    locationId: string;
    hotspotName: string;
    feedbackType: 'confirm' | 'correct';
    predictedHabitat: string;
    predictedDisplayHabitat: string;
    predictedFamily: string;
    classifierVersion: string;
    suggestedHabitat: string;
    suggestedRuleLabel?: string;
    suggestionCount: number;
    latestFeedbackAt?: string;
    latestNotes?: string;
    feedbackIds: number[];
};

export type PendingHotspotHabitatFeedbackResponse = {
    status: string;
    items: PendingHotspotHabitatFeedbackItem[];
};

export const getPendingHotspotHabitatFeedback = async (limit = 200) => {
    const response = await fetch(getApiUrl(`/api/admin/hotspots/habitat-feedback/pending?limit=${limit}`), {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    });

    if (!response.ok) {
        let message = `Pending habitat feedback request failed with ${response.status}`;

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Ignore parse errors and surface the HTTP status instead.
        }

        throw new Error(message);
    }

    return await response.json() as PendingHotspotHabitatFeedbackResponse;
};
